/**
 * useProjectFirstSteps — ответ ручки «Первые шаги» текущего проекта
 * (WEB-3752 юнит 2: пустая аналитика по `hasVisits === false`, решения
 * владельца 24.10 п. 20, 39).
 *
 *  - Один запрос на заход в проект; смена проекта — новый запрос, а ответ
 *    прежнего проекта сразу снимается и поздно пришедший отбрасывается
 *    (тот же приём, что `useAnalyticsFilterOptions`, WEB-1372 п.1).
 *  - Отказ ручки — `null`, как «ещё не ответили»: экран ведёт себя как
 *    обычно и ошибку не показывает (пустое состояние — подсказка, а не
 *    обязательная часть страницы).
 */
import { useEffect, useState } from 'react';
import { firstStepsApi, type ProjectFirstSteps } from '@/api/firstSteps';

export function useProjectFirstSteps(
  projectId: string | undefined,
): ProjectFirstSteps | null {
  const [state, setState] = useState<{
    projectId?: string;
    data: ProjectFirstSteps | null;
  }>({ data: null });

  useEffect(() => {
    if (!projectId) return;
    let cancelled = false;
    firstStepsApi
      .forProject(projectId)
      .then((data) => {
        if (!cancelled) setState({ projectId, data });
      })
      .catch(() => {
        if (!cancelled) setState({ projectId, data: null });
      });
    return () => {
      cancelled = true;
    };
  }, [projectId]);

  return projectId && state.projectId === projectId ? state.data : null;
}
